import { Form } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { Load } from "../load/load";
import { eliminarUbicaciones } from "../../api/ubicaciones";
import { toast } from "react-toastify";
import queryString from "query-string";
import { LogsInformativos } from "../logs/logs";

export default function EliminarUbicaciones({ data, history, setShow }) {

    const idDocumental = data[0];

    const dataTemp = {
        nombre: data[1],
    };

    const [formData, setFormData] = useState(initialFormValue(dataTemp));

    //load
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Simula una carga de datos
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, []);

    //insert
    const onSubmit = (e) => {
        e.preventDefault();

        try {
            setLoading(true);
            // Sube a cloudinary la imagen principal del producto

            eliminarUbicaciones(idDocumental).then((response) => {
                const { data } = response;
                //notificacion

                toast.success(data.mensaje);

                history({
                    search: queryString.stringify(""),
                });
                LogsInformativos("Se ha eliminado la ubicacion " +  idDocumental)
                setLoading(false);
                setShow(false);
                //cancelarRegistro()
            });
        } catch (e) {
            console.log(e);
        }
    };

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    return (
        <>
            {loading && <Load />}
            <div className='generalDoctores'>
                <Form className='formDoctores' onSubmit={onSubmit} onChange={onChange}>
                    <Form.Group>
                        <Form.Label>Nombre: </Form.Label>
                        <Form.Control
                            type='text'
                            placeholder='Ingresa el nombre de la ubicacion'
                            defaultValue={formData.nombre}
                            name="nombre"
                            disabled
                        />
                    </Form.Group>
                    <br />
                    <label></label>
                    <div className="divSubmit">
                        <input className="submit" value="Enviar" type="submit" />
                    </div>
                </Form>
            </div>
        </>
    );
}

function initialFormValue(data) {
    return {
        nombre: data.nombre,
    };
}
